var _rect, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSchedule = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1679",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8958 13.7709L13.7708 12.8959L10.625 9.75004V5.83337H9.37499V10.25L12.8958 13.7709ZM9.99999 17.9167C8.90277 17.9167 7.87166 17.7084 6.90666 17.2917C5.94111 16.875 5.10416 16.3125 4.39583 15.6042C3.68749 14.8959 3.12499 14.0589 2.70833 13.0934C2.29166 12.1284 2.08333 11.0973 2.08333 10C2.08333 8.90282 2.29166 7.87143 2.70833 6.90587C3.12499 5.94087 3.68749 5.10421 4.39583 4.39587C5.10416 3.68754 5.94111 3.12504 6.90666 2.70837C7.87166 2.29171 8.90277 2.08337 9.99999 2.08337C11.0972 2.08337 12.1286 2.29171 13.0942 2.70837C14.0592 3.12504 14.8958 3.68754 15.6042 4.39587C16.3125 5.10421 16.875 5.94087 17.2917 6.90587C17.7083 7.87143 17.9167 8.90282 17.9167 10C17.9167 11.0973 17.7083 12.1284 17.2917 13.0934C16.875 14.0589 16.3125 14.8959 15.6042 15.6042C14.8958 16.3125 14.0592 16.875 13.0942 17.2917C12.1286 17.7084 11.0972 17.9167 9.99999 17.9167ZM9.99999 16.6667C11.8472 16.6667 13.4203 16.0175 14.7192 14.7192C16.0175 13.4203 16.6667 11.8473 16.6667 10C16.6667 8.15282 16.0175 6.57976 14.7192 5.28087C13.4203 3.98254 11.8472 3.33337 9.99999 3.33337C8.15277 3.33337 6.57999 3.98254 5.28166 5.28087C3.98277 6.57976 3.33333 8.15282 3.33333 10C3.33333 11.8473 3.98277 13.4203 5.28166 14.7192C6.57999 16.0175 8.15277 16.6667 9.99999 16.6667Z",
    fill: "#5A5A5A"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSchedule, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/schedule.5bdb7161.svg";
export { ForwardRef as ReactComponent };